import { render, staticRenderFns } from "./ConfirmMembersDialog.vue?vue&type=template&id=3c31a872&scoped=true"
import script from "./ConfirmMembersDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmMembersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c31a872",
  null
  
)

export default component.exports